<template>
  <b-modal id="affected-machines-modal" ref="affected-machines-modal" hide-footer>
    <template #modal-title>
      <div>
        <h5 class="mb-0">Machines</h5>
        <small class="text-muted">Dealer: {{ dealer }}</small>
      </div>
    </template>
    <b-table :items="tableItems" :fields="fields" small striped class="mb-0">
      <template #cell(serial)="data">
        <router-link :to="'/machine/' + data.item.serial" @click.native="$refs['affected-machines-modal'].hide()">
          {{ data.item.serial }}
        </router-link>
      </template>
    </b-table>
  </b-modal>
</template>

<script>

export default {
  name: 'AccessRulesModalAffectedMachines',
  data () {
    return {
      serials: [],
      dealer: null,
      fields: [{ key: 'serial', sortable: true}],
    }
  },
  computed: {
    tableItems: function () {
      return this.serials.map((serial) => {
        return { serial };
      });
    }
  },
  methods: {
    show (data, dealer) {
      this.serials = data
      this.dealer = dealer
      this.$refs['affected-machines-modal'].show()
    }
  }
}
</script>

<style lang="scss">
</style>
